/**
 * Checks if the specified list has items with trackables,
 * where `trackableStatus` is {@link TrackableStatus.Confirmed} or {@link TrackableStatus.Unconfirmed}.
 *
 * @param items
 * @returns
 */
export function checkForTrackables(items) {
    // Bad code because if `item.trackableStatus` is `undefined` it returns true;
    // return Boolean(items?.some((item) => item.trackableStatus !== TrackableStatus.None));
    return Boolean(items?.some((item) => Boolean(item.trackableStatus)));
}
